import { useNavigate } from "react-router-dom";
import { CustomerAppointmentBooking } from "@/components/CustomerAppointmentBooking";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function BookAppointment() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted/20 flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl">
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle className="text-2xl">Book an Appointment</CardTitle>
              <CardDescription>
                Schedule a time to meet with us. We'll send you a confirmation email once your appointment is booked.
              </CardDescription>
            </div>
            <Button
              variant="outline"
              size="icon"
              onClick={() => navigate('/')}
              className="shrink-0"
              aria-label="Go to home page"
            >
              <Home className="h-4 w-4" />
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <CustomerAppointmentBooking />
        </CardContent>
      </Card>
    </div>
  );
}
